import React from "react";
import PropTypes from "prop-types";

import { Image } from "@sparefoot/react-commons";
import { Text, Paragraph, H3 } from "components/core/Typography";

import "./ReviewCard.scss";

const ReviewCard = ({ title, body, author, imageSrc }) => (
	<div className="testimonial-card">
		<div className="card-image">
			<Image
				src={imageSrc}
				alt={author}
				lazy
				width="152"
				height="152"
			/>
		</div>
		<div className="card-body">
			<div className="card-header">
				<H3 size="standard">{title}</H3>
				<div>
					<Text className="author-text">{`by ${author}`}</Text>
				</div>
			</div>
			<Paragraph
				size="small"
				className="quote-text"
			>{`${body}"`}</Paragraph>
		</div>
	</div>
);

ReviewCard.propTypes = {
	body: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	author: PropTypes.string.isRequired,
	imageSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default ReviewCard;
